'use client';
import { Pronouns, Title } from '../../types';
import { ProfilePicture } from '../profile-picture/ProfilePicture';
import { Column, Row } from '../../styles';
import * as React from 'react';
import { useTheme } from '../../hooks';
import { BoxProps } from '@mui/material';
import { UserInfoSubtitle, UserInfoTitle, UserPronouns } from './styles';
import { useTranslations } from 'next-intl';
import { Institution } from '../../types/Institution';

interface Props extends BoxProps {
    title?: Title;
    pronouns?: Pronouns;
    firstname: string;
    lastname: string;
    profilePicture?: string;
    userPosition: string;
    showRoleLabel?: boolean;
    showSubtitle?: boolean;
    institution?: Institution;
}

const UserInfo = ({
    title,
    pronouns,
    firstname,
    lastname,
    profilePicture,
    institution,
    userPosition,
    showSubtitle = true,
    ...boxProps
}: Props) => {
    const t = useTranslations('user');
    const username = `${title ? t(title) + ' ' : ''}${firstname} ${lastname}`;
    const theme = useTheme();

    const renderSubtitle = () => {
        const show = showSubtitle && institution;
        return show ? (
            <UserInfoSubtitle color={theme.colors.onSurfaceVariant}>
                {institution.name}
                {`${userPosition ? ' | ' : ''}`}
                {userPosition}
            </UserInfoSubtitle>
        ) : null;
    };

    return (
        <Row py={1} overflow={'hidden'} {...boxProps}>
            <ProfilePicture imageUrl={profilePicture} altText={`Profile Picture of ${username}`} />
            <Column overflow={'hidden'} ml={2}>
                <Row gap={0.5}>
                    <UserInfoTitle color={theme.colors.onSurface}>{username}</UserInfoTitle>
                    {pronouns && (
                        <UserPronouns>{` (${t(pronouns).toLocaleLowerCase()})`}</UserPronouns>
                    )}
                </Row>
                {renderSubtitle()}
            </Column>
        </Row>
    );
};

export { UserInfo };
